import type { ReactElement } from "react";

import { Button } from "@similarweb/ui-components";
import { useTranslate } from "@similarweb/i18n-provider";
import { Stack } from "@similarweb/ui-components/foundations";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import { StyledEmptyStateIcon, StyledEmptySubtitle, StyledEmptyTitle } from "./styles";

const ListDropdownEmptyState = (): ReactElement => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="8px"
            alignItems="center"
            paddingY="24px"
            paddingX="16px"
            data-automation="saved-search-webhooks-list-empty-state"
        >
            <StyledEmptyStateIcon iconName="no-data-lab" />
            <StyledEmptyTitle>
                {translate("si.management.saved-search-webhooks.list-empty.title")}
            </StyledEmptyTitle>
            <StyledEmptySubtitle>
                {translate("si.management.saved-search-webhooks.list-empty.subtitle")}
            </StyledEmptySubtitle>
            <Button
                type="primary"
                onClick={() => siNavigator.goToAdvancedSearchPage()}
                dataAutomation="saved-search-webhooks-create-search"
            >
                {translate("si.management.saved-search-webhooks.list-empty.create-button")}
            </Button>
        </Stack>
    );
};

export default ListDropdownEmptyState;
